import { render, staticRenderFns } from "./CofAnalytics.vue?vue&type=template&id=96bcb288&scoped=true&"
import script from "./CofAnalytics.vue?vue&type=script&lang=js&"
export * from "./CofAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./CofAnalytics.vue?vue&type=style&index=0&id=96bcb288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bcb288",
  null
  
)

export default component.exports